import { takeLatest, put, select, call } from 'redux-saga/effects';
import size from 'lodash/size';
import head from 'lodash/head';

import {
  targetUserIdSelector,
  loggedUserIdSelector,
} from '../../context/selectors';
import {
  activeChannelIdSelector,
  availableChannelsSelector,
} from '../selectors';
import { removedMemberIdSelector } from '../../board/selectors/removeParticipant';
import chatConsts from '../constants';
import {
  defaultFirstActiveChannel,
  defaultFirstContextUser,
} from '../../board/selectors/channels';
import { consts as settings } from '../../board/settings';
import { isDesktop } from '../../../utils/mobileHelpers';
import { consts as drawer } from '../../ui/drawer';
import { consts as sidebar } from '../../ui/sidebar';
import { uiDrawerSelector, uiSidebarSelector } from '../../ui/selectors';
import { MESSAGES } from '../../../constants/routes';
import { currentLocationSelector } from '../../common/selectors';

function* toggleMobileSidebars() {
  const drawerState = yield select(uiDrawerSelector);
  const sidebarState = yield select(uiSidebarSelector);

  if (!drawerState.visible) {
    yield put({ type: drawer.TOGGLE_VISIBILITY });
  }

  if (sidebarState.visible) {
    yield put({ type: sidebar.TOGGLE_VISIBILITY });
  }
}

function* firstChatSelection() {
  const firstChannelId = yield select(defaultFirstActiveChannel);
  const firstContextUser = yield select(defaultFirstContextUser);

  yield put({
    type: chatConsts.SET_ACTIVE_CHANNEL_ID,
    payload: firstChannelId,
  });

  if (firstContextUser) {
    yield put({
      type: settings.SET_LAST_USER_ID,
      payload: { id: firstContextUser },
    });
    yield put({
      type: settings.REMOVE_LAST_SOCIAL_ID,
    });
  }
}

function* firstChannelSelection() {
  const targetUserId = yield select(targetUserIdSelector);
  const currentChannels = yield select(availableChannelsSelector);
  const activeSubchannelId = parseInt(
    head(Object.keys(currentChannels[targetUserId])),
    10,
  );

  yield put({
    type: chatConsts.SET_ACTIVE_CHANNEL_ID,
    payload: activeSubchannelId,
  });

  yield put({
    type: chatConsts.SET_LAST_CHANNEL_ID,
    payload: { id: activeSubchannelId, targetUserId },
  });
}

function* removeChannelActivityWorker(action) {
  const {
    payload: { channelId },
  } = action;
  const targetUserId = yield select(targetUserIdSelector);
  const activeChannelId = yield select(activeChannelIdSelector);
  const availableChannels = yield select(availableChannelsSelector);
  const removedMemberId = yield select(removedMemberIdSelector);
  const loggedUserId = yield select(loggedUserIdSelector);
  const currentLocation = yield select(currentLocationSelector);
  const showRemoveMessage =
    loggedUserId !== removedMemberId && currentLocation === `/${MESSAGES}`;

  if (size(availableChannels[targetUserId]) > 0) {
    yield put({
      type: chatConsts.REMOVE_CONTEXT_CHANNEL,
      payload: { channelId, contextId: targetUserId },
    });
  } else {
    yield put({
      type: chatConsts.REMOVE_SOCIAL_CHANNEL,
      payload: { channelId, contextId: targetUserId },
    });
  }

  if (size(availableChannels[targetUserId]) === 1) {
    yield put({
      type: chatConsts.REMOVE_CONTEXT,
      payload: { contextId: targetUserId },
    });
  }

  if (activeChannelId === channelId) {
    if (showRemoveMessage) {
      yield put({
        type: chatConsts.REMOVE_CHANNEL_MESSAGE,
      });
    }

    if (!isDesktop()) {
      yield call(toggleMobileSidebars);
    } else if (targetUserId) {
      yield call(firstChannelSelection);
    } else {
      yield call(firstChatSelection);
    }
  }
}

export default function* removeChannelActivitySaga() {
  yield takeLatest([chatConsts.REMOVE_CHANNEL], removeChannelActivityWorker);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/removeChannelActivity.js